
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Interaction/HorizontalScrollContent.html",
      function () {
        return require("private-next-pages/Interaction/HorizontalScrollContent.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Interaction/HorizontalScrollContent.html"])
      });
    }
  